export const MAX_GROUP_TITLE_TEXT_LENGTH = 40
